import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getUserInfo } from '../../reducers/user';
import { getNews } from '../../reducers/news';

import SignIn from '../signin';
import SignOut from '../signout';
import Main from '../main';
import PrivateRoute from '../app/privateRoute';
import NewsPanel from './newsPanel';

import { Container, Header, Menu } from 'semantic-ui-react';

class App extends Component {

  constructor(props) {
    super(props);

    // Check if user is already logged in
    this.props.getUserInfo();
    this.props.getNews();
  }

  render() {

    return (
      <div>
        <Menu fixed='top' inverted>
          <Container>
            <Menu.Item href={'https://www.cgi.fi'} as='a'><img src={require('../../CGI_Logo_color.png')} alt="CGI"/></Menu.Item>
            <Menu.Item onClick={() => this.props.gotoMainPage()} as='a' header>Julkaisupalvelu</Menu.Item>
            {!this.props.user.isLoggedIn && <Menu.Item onClick={() => this.props.gotoSignInPage()}>Kirjaudu sisään</Menu.Item>}
            {this.props.user.isLoggedIn && <Menu.Item onClick={() => this.props.gotoSignOutPage()}>Kirjaudu ulos</Menu.Item>}
          </Container>
        </Menu>
        <Container text style={{ paddingTop: '7em' }}>
          <Header as='h1' className='title'>Julkaisupalvelu</Header>
          <NewsPanel />
          <PrivateRoute exact path="/" component={Main} authed={this.props.user.isLoggedIn} />
          <Route exact path="/sign" component={SignIn} />
          <PrivateRoute exact path="/signout" component={SignOut} authed={this.props.user.isLoggedIn} />
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    routing: state.routing
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  getUserInfo: () => getUserInfo(),
  getNews: () => getNews(),
  gotoSignOutPage: () => push('/signout'),
  gotoSignInPage: () => push('/sign'),
  gotoManagementPage: () => push('/manage'),
  gotoMainPage: () => push('/'),
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/containers/app/index.js